// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Mexico from '../_raw/flag/icon_flag_mexico.png';

export default () => <img src={Mexico} alt="Mexico" />;
